<template>
  <div id="loader" v-if="LoadingMain" style="margin-top: 30vh">
    <loader-comp></loader-comp>
  </div>
  <div v-else>
    <div v-if="Message == 0">
      <div id="assign-order" v-if="Onboard">
        <div id="assign-heading">
          <h2>Assign Order</h2>
        </div>
        <div id="form">
          <div id="form-row-1">
            <address-field @message="handleMessage"></address-field>
            <div>
              <input
                type="text"
                :class="Error == 1 ? 'input-error' : 'input-1'"
                placeholder="Customer Name"
                v-model="customer_name"
                ref="input-1"
                @keydown="moveToNextInput($event, 'input-2')"
              />
              <h2 class="error-message" v-if="Error == 1">
                {{ ErrorMessage }}
              </h2>
            </div>
            <div>
              <input
                type="text"
                :class="Error == 2 ? 'input-error' : 'input-1'"
                placeholder="Customer Phone"
                v-model="customer_phone"
                ref="input-2"
                @keydown="moveToNextInput($event, 'input-4')"
                inputmode="numeric"
              />
              <h2 class="error-message" v-if="Error == 2">
                {{ ErrorMessage }}
              </h2>
            </div>
          </div>
          <div id="assign-heading">
            <h2>Order Details</h2>
          </div>
          <div id="form-row-3">
            <div>
              <input
                type="text"
                :class="Error == 4 ? 'input-error' : 'input-1'"
                placeholder="No. of Bags"
                v-model="bags"
                ref="input-4"
                inputmode="numeric"
              />
              <h2 class="error-message" v-if="Error == 4">
                {{ ErrorMessage }}
              </h2>
            </div>
            <payment-field></payment-field>
            <!-- <input type="text" class="input-1" placeholder="Delivery Instructions" v-model="instructions" ref="input-6" @keydown="moveToNextInput($event, 'input-7')" > -->
          </div>
          <div id="assign-heading">
            <h2>Enter Order Value</h2>
          </div>
          <div id="form-row-2">
            <div id="pricing">
              <div>
                <input
                  type="text"
                  :class="Error == 7 ? 'input-min-error' : 'input-min'"
                  placeholder="£0.00"
                  v-model="orderValue"
                  ref="input-6"
                  @keydown="moveToNextInput($event, 'input-8')"
                  inputmode="numeric"
                />
                <div v-if="Error == 7" class="small-error-message">
                  {{ ErrorMessage }}
                </div>
              </div>
              <h4 id="price-info1">
                In case of cash delivery this amount will be collected by the
                driver.
              </h4>
            </div>
          </div>
          <div id="assign-heading">
            <h2>Delivery Cost</h2>
          </div>
          <div id="form-row-2">
            <div>
              <div id="generate-price">
                <h2>£{{ DeliveryCost }}</h2>
                <div
                  :class="
                    DeliveryCalculated == true
                      ? 'generate-passive'
                      : 'generate-active'
                  "
                  @click="Cost"
                >
                  Calculate Delivery Cost
                </div>
              </div>
              <h4 id="price-info2">
                Price will be auto-generated according to the distance
              </h4>
            </div>
          </div>
        </div>
        <div id="loader" v-if="Loading">
          <loader-comp></loader-comp>
        </div>
        <div style="margin: 1.8rem 0 10rem 0">
          <submit-button
            Text="Assign Order Now"
            @click="submit"
            v-if="DeliveryCalculated"
          ></submit-button>
          <alternative-button
            Text="Assign Order Now"
            v-else
          ></alternative-button>
        </div>
      </div>
      <div v-else id="onboard">
        <div id="message">
          <h1 id="heading">Complete Stripe Onboarding</h1>
          <h2 id="content">
            The Stripe onboarding process is not completed. This pivotal step
            will ensure your future payments are both seamless and secure. Your
            trust in us is greatly appreciated, and we are honored to have you
            on board. Let's commence the onboarding!
          </h2>
        </div>
        <submit-button Text="Continue" @click="onboardRedirect"></submit-button>
      </div>
    </div>
    <div class="message-comp" v-if="Message == 1">
      <server-crash msg="Something went wrong at our end"></server-crash>
    </div>
    <div class="message-comp" v-if="Message == 2">
      <error-comp msg="Failed to fetch outlet profile"></error-comp>
    </div>
    <div class="message-comp" v-if="Message == 3">
      <empty-list msg="No driver found"></empty-list>
    </div>
    <div class="message-comp" v-if="Message == 4">
      <server-crash msg="Something went wrong at our end"></server-crash>
    </div>
    <div class="message-comp" v-if="Message == 5">
      <error-comp msg="Failed to place order"></error-comp>
    </div>
    <div class="message-comp" v-if="Message == 6">
      <server-crash
        msg="Your Account is on hold please await access approval from Eat Express"
      ></server-crash>
    </div>
    <div class="message-comp" v-if="Message == 10">
      <server-crash msg="Delivery cannot be made to this route"></server-crash>
    </div>
    <div class="message-comp" v-if="Message == 12">
      <server-crash msg="Something went wrong at our end"></server-crash>
    </div>
    <div class="message-comp" v-if="Message == 11">
      <error-comp msg="Delivery not possible to this route"></error-comp>
    </div>
    <div class="message-comp" v-if="Message == 13">
      <error-comp msg="Failed to calculate delivery price"></error-comp>
    </div>
    <div class="message-comp" v-if="Message == 69">
      <error-comp msg="Please calculate delivery price first"></error-comp>
    </div>
  </div>
</template>

<script>
import SubmitButton from "../home/submit-button.vue";
import AlternativeButton from "../home/alternative-button.vue";
import AddressField from "./address-comp.vue";
import PaymentField from "../home/payment-field.vue";
import LoaderComp from "../general/loader-comp.vue";
import ErrorComp from "../messages/error-comp.vue";
import ServerCrash from "../messages/server-crash.vue";
import EmptyList from "../messages/empty-comp.vue";
import Cookies from "js-cookie";
export default {
  components: {
    SubmitButton,
    AlternativeButton,
    PaymentField,
    AddressField,
    LoaderComp,
    ErrorComp,
    ServerCrash,
    EmptyList,
  },
  data() {
    return {
      customer_phone: "",
      customer_name: "",
      address_1: "",
      payment: "",
      instructions: "",
      bags: "",
      price: "",
      orderValue: "",
      errorField: "",
      errorMessage: "",
      loading: false,
      onboard: true,
      message: 0,
    };
  },
  watch: {
    bags(value) {
      if (Number.isInteger(parseFloat(value)) == false) {
        this.errorField = 4;
        this.errorMessage = "Please enter a number";
      } else if (value <= 0) {
        this.errorField = 4;
        this.errorMessage = "Please enter number of bags";
      } else {
        this.errorField = 0;
        this.errorMessage = "";
      }
    },
    orderValue(value) {
      let stat = !isNaN(parseFloat(value)) && isFinite(parseFloat(value));
      if (stat == false) {
        this.errorField = 7;
        this.errorMessage = "Please enter a number";
      } else if (value <= 0) {
        this.errorField = 7;
        this.errorMessage = "Please enter order value";
      } else {
        this.errorField = 0;
        this.errorMessage = "";
      }
    },
    customer_phone(new_value, old_value) {
      if (new_value.length > 11) {
        this.customer_phone = old_value;
      }
    },
  },
  computed: {
    Error() {
      return this.errorField;
    },
    ErrorMessage() {
      return this.errorMessage;
    },
    DeliveryCost() {
      return this.$store.getters["orders/getDeliveryCost"];
    },
    Loading() {
      return this.$store.getters["user/getLoading"];
    },
    LoadingMain() {
      return this.loading;
    },
    Onboard() {
      return this.onboard;
    },
    Message() {
      return this.message;
    },
    DeliveryCalculated() {
      return this.$store.getters["orders/getCostCalculated"];
    },
  },
  methods: {
    async submit() {
      //validation
      let address = this.$store.getters["orders/getAddress"];
      let mobileCheck = await this.mobileCheck();
      let paymentCheck = this.$store.getters["user/getPaymentMode"];
      let bagCheck = true;
      let orderCheck = true;
      if (this.bags != "") {
        bagCheck = Number.isInteger(parseFloat(this.bags));
      }
      if (this.orderValue != "") {
        orderCheck = await this.floatCheck(this.orderValue);
      }
      if (this.customer_name == "") {
        this.errorField = 1;
        this.errorMessage = "This field is required";
      } else if (this.customer_phone == "") {
        this.errorField = 2;
        this.errorMessage = "This field is required";
      } else if (!mobileCheck) {
        this.errorField = 2;
        this.errorMessage = "Please enter a valid phone number";
      } else if (address == "") {
        this.$store.commit("order/setAddress", { value: "error" });
      } else if (this.bags == "") {
        this.errorField = 4;
        this.errorMessage = "This field is required";
      } else if (bagCheck == false) {
        this.errorField = 4;
        this.errorMessage = "Please enter a valid value";
      } else if (this.bags == 0) {
        this.errorField = 4;
        this.errorMessage = "Please enter number of bags";
      } else if (paymentCheck == "") {
        this.$store.commit("orders/setPaymentFieldError", { value: true });
      } else if (this.orderValue == "") {
        this.errorField = 7;
        this.errorMessage = "This field is required";
      } else if (!orderCheck) {
        this.errorField = 7;
        this.errorMessage = "Please enter a valid value";
      } else if (this.orderValue == 0) {
        this.errorField = 7;
        this.errorMessage = "Enter food order value";
      } else {
        this.$store.commit("user/setLoading", { value: true });
        let res = await this.$store.dispatch("orders/placeOrder", {
          customer_name: this.customer_name,
          customer_phone: this.customer_phone,
          address: address,
          mode_of_payment: paymentCheck,
          bags: this.bags,
          delivery_instructions: "",
          food_order_value: this.orderValue,
        });
        this.$store.commit("user/setLoading", { value: false });
        if (res.status == 200) {
          this.$router.push({ name: "liveOrder", params: { id: res.data } });
        } else if (res.status == 404) {
          this.message = 3;
          setTimeout(() => {
            this.$store.commit("user/changeHomePage", { value: 1 });
          }, 1500);
        } else if (res.status == 400) {
          this.message = 10;
          setTimeout(() => {
            this.message = 0;
          }, 3000);
        } else if (res.status == 500) {
          this.message = 4;
          setTimeout(() => {
            this.message = 0;
          }, 3000);
        } else {
          this.message = 5;
          setTimeout(() => {
            this.message = 0;
          }, 3000);
        }
      }
    },
    async mobileCheck() {
      const phonePattern = /^[0-9]{11}$/;
      return phonePattern.test(this.customer_phone);
    },
    async numericCheck(value) {
      const phonePattern = /^\d+$/;
      return phonePattern.test(value);
    },
    async floatCheck(value) {
      return /^-?\d*\.?\d+$/.test(value);
    },
    async Cost() {
      let address = this.$store.getters["orders/getAddress"];
      if (address == "") {
        this.$store.commit("orders/setAddress", { value: "error" });
      } else {
        let val = await this.$store.dispatch("orders/deliveryCost", {
          value: address,
        });
        if (val.stat == 200) {
          this.$store.commit("orders/setDeliveryCost", { value: val.data });
          this.$store.commit("orders/setCostCalculated", { value: true });
        } else if (val.stat == 400) {
          this.message = 11;
          setTimeout(() => {
            this.message = 0;
          }, 2000);
        } else if (val.stat == 500) {
          this.message = 12;
          setTimeout(() => {
            this.message = 0;
          }, 2000);
        } else {
          this.message = 13;
          setTimeout(() => {
            this.message = 0;
          }, 2000);
        }
      }
    },
    async moveToNextInput(event, nextInputName) {
      if (event.key === "Enter") {
        if (nextInputName == "input-8") {
          await this.submit();
        } else {
          this.$refs[nextInputName].focus();
        }
      }
    },
    async onboardRedirect() {
      this.loading = true;
      let res = await this.$store.dispatch("user/stripeOnboard");
      this.loading = false;
      this.$store.commit("user/setLoading", { value: false });
      if (res.status == 200) {
        window.location.replace(res.data);
      } else if (res.status == 500) {
        alert("oops something went wrong");
      } else {
        alert("failed to continue");
      }
    },
    handleMessage(value) {
      this.message = value;
      setTimeout(() => {
        this.message = 0;
      }, 2500);
    },
    costPopup() {
      this.message = 69;
      setTimeout(() => {
        this.message = 0;
      }, 1500);
    },
  },
  async mounted() {
    if (!Cookies.get("authenticated")) {
      this.$router.push({ name: "landing" });
    }
    this.$store.commit("orders/setAddress", { value: "" });
    this.$store.commit("orders/setDeliveryCost", { value: 0 });
    this.$store.commit("user/setPaymentMode", { value: "" });
    this.$store.commit("orders/setCostCalculated", { value: false });
    this.loading = true;
    let res = await this.$store.dispatch("user/getProfile");
    this.loading = false;
    if (res.status == 200) {
      if (res.data.is_suspended == true) {
        this.message = 6;
        return;
      }
      this.onboard = res.data.is_stripe_onboarding_complete;
    } else if (res.status == 500) {
      this.message = 1;
    } else {
      this.message = 2;
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter&display=swap");
#assign-order {
  width: 100vw;
  margin-top: 10px;
  height: auto;
  overflow-x: hidden;
}
#assign-order::-webkit-scrollbar {
  display: none;
}
.message-comp {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10vh;
}
@media only screen and (max-width: 480px) {
  #assign-heading {
    padding-left: 8vw;
    padding-top: 2vh;
  }
  #assign-heading h2 {
    color: #413f3f;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-bottom: 15px;
  }

  #form {
    margin-top: 2vh;
  }
  .input-1,
  .input-1:focus,
  .input-1::selection {
    width: 90vw;
    margin-left: 5vw;
    height: 54px;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
    margin-bottom: 24.52px;
    border: none;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-1::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-error,
  .input-error:focus,
  .input-error::selection {
    width: 90vw;
    margin-left: 5vw;
    height: 54px;
    border-radius: 30px;
    background: #fff;
    border: 1px solid rgba(255, 0, 0, 0.601);
    margin-bottom: 24.52px;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-error::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-min,
  .input-min:focus,
  .input-min::selection {
    width: 30vw;
    height: 54px;
    margin-left: -2vw;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
    border: none;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-right: 0px;
  }
  .input-min::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-min-error,
  .input-min-error:focus,
  .input-min-error::selection {
    width: 30vw;
    height: 54px;
    margin-left: -2vw;
    border-radius: 30px;
    background: #fff;
    border: 1px solid rgba(255, 0, 0, 0.601);
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-right: 0px;
  }
  .input-min-error::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  #form-row-2 {
    padding-left: 8vw;
    margin-bottom: 15px;
  }
  #form-row-2 h3 {
    color: #413f3f;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.317px;
  }
  #pricing {
    display: inline-flex;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  #form-row-2 h2 {
    color: var(--brand-color, #25ad34);
    font-family: Inter;
    font-size: 22.807px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.228px;
  }
  #price-info1 {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    width: 60vw;
    margin-top: 0px;
    margin-left: 4vw;
  }
  #price-info2 {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-top: 1.78vh;
    margin-left: 2vw;
  }
  #generate-price {
    display: flex;
  }
  .generate-passive {
    margin-left: 5vw;
    width: 148px;
    height: 43px;
    margin-top: -6px;
    border-radius: 16px;
    background: var(--Brand-color-3, #8d8d8d);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--White, #fff);
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .generate-active {
    margin-left: 5vw;
    width: 148px;
    height: 43px;
    margin-top: -6px;
    border-radius: 16px;
    background: var(--brand-color, #25ad34);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--White, #fff);
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  #loader {
    width: 100vw;
    display: flex;
    justify-content: center;
    margin-top: 1vh;
    margin-bottom: auto;
  }
  #message {
    padding-top: 5vh;
  }
  #heading {
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  #content {
    color: #242424;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.2px;
    margin-top: 5vh;
    margin-bottom: 5vh;
    width: 90vw;
    margin-left: 5vw;
  }
  .error-message {
    font-family: Inter;
    font-size: 14px;
    color: rgba(255, 0, 0, 0.601);
    font-weight: 400;
    margin-top: -20px;
    margin-left: 6vw;
  }
  .small-error-message {
    font-size: 14px;
    font-family: Inter;
    color: rgba(255, 0, 0, 0.601);
    margin-top: -1px;
    margin-left: 4px;
  }
}
@media only screen and (min-width: 481px) and (max-width: 960px) {
  #assign-heading {
    padding-left: 3vw;
    padding-top: 2vh;
  }
  #assign-heading h2 {
    color: #413f3f;
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-bottom: 15px;
  }

  #form {
    margin-top: 1vh;
  }
  #form-row-1,
  #form-row-3 {
    width: 97vw;
    display: grid;
    padding-left: 3vw;
    grid-template-columns: repeat(2, 47vw);
    overflow-x: hidden;
  }
  .input-1,
  .input-1:focus,
  .input-1::selection {
    width: 45vw;
    height: 67px;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
    margin-bottom: 21.52px;
    border: none;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-1::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 19px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-error,
  .input-error:focus,
  .input-error::selection {
    width: 45vw;
    height: 67px;
    border-radius: 30px;
    background: #fff;
    letter-spacing: 0.2px;
    border: 1px solid rgba(255, 0, 0, 0.601);
    margin-bottom: 21.52px;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-error::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 19px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-min,
  .input-min:focus,
  .input-min::selection {
    width: 45vw;
    height: 67px;
    margin-left: 2vw;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
    border: none;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-right: 0px;
  }
  .input-min::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-min-error,
  .input-min-error:focus,
  .input-min-error::selection {
    width: 45vw;
    height: 67px;
    margin-left: 2vw;
    border-radius: 30px;
    background: #fff;
    border: 1px solid rgba(255, 0, 0, 0.601);
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-right: 0px;
  }
  .input-min-error::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  #form-row-2 {
    padding-left: 1.8vw;
    padding-top: 0px;
    margin-bottom: 4.5vh;
  }
  #form-row-2 h3 {
    color: #131313;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-bottom: 7px;
    margin-left: 3vw;
  }
  #form-row-2 h2 {
    color: var(--brand-color, #25ad34);
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-left: 3vw;
  }
  #price-info1 {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    width: 40vw;
    float: left;
    margin-left: 5vw;
    margin-top: -0.5vh;
  }
  #price-info2 {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    float: left;
    margin-left: 3vw;
    margin-top: 0.5vh;
  }
  #pricing {
    display: inline-flex;
    margin-bottom: 20px;
  }
  #generate-price {
    display: flex;
  }
  .generate-passive {
    margin-left: 5vw;
    width: 200px;
    height: 51px;
    border-radius: 16px;
    background: var(--Brand-color-3, #8d8d8d);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--White, #fff);
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .generate-active {
    margin-left: 5vw;
    width: 200px;
    height: 51px;
    border-radius: 16px;
    background: var(--brand-color, #25ad34);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--White, #fff);
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .error-message {
    font-family: Inter;
    font-size: 14px;
    color: rgba(255, 0, 0, 0.601);
    font-weight: 400;
    margin-top: -20px;
    margin-left: 14px;
  }
  #loader {
    width: 100vw;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
    margin-bottom: auto;
  }
  #message {
    padding-top: 10vh;
  }
  #heading {
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  #content {
    color: #242424;
    text-align: center;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px; /* 142.857% */
    letter-spacing: 0.2px;
    margin-top: 2vh;
    margin-bottom: 5vh;
    width: 80vw;
    margin-left: 10vw;
  }
  .small-error-message {
    font-size: 19px;
    font-family: Inter;
    color: rgba(255, 0, 0, 0.601);
    margin-top: -1px;
    margin-left: 24px;
  }
}
@media only screen and (min-width: 961px) {
  #assign-heading {
    padding-left: 5vw;
    padding-top: 2vh;
  }
  #assign-heading h2 {
    color: #413f3f;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-bottom: 10px;
  }
  #form {
    margin-top: 4vh;
  }
  #form-row-1,
  #form-row-3 {
    width: 90vw;
    margin-bottom: 0vh;
    display: grid;
    padding-left: 5vw;
    padding-right: 5vw;
    grid-template-columns: repeat(3, 20vw);
    overflow-x: hidden;
    column-gap: 10vw;
    overflow-y: auto;
  }
  #form-row-1::-webkit-scrollbar,
  #form-row-2::-webkit-scrollbar {
    display: none;
  }
  .input-1,
  .input-1:focus,
  .input-1::selection {
    width: 20vw;
    height: 47px;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
    margin-bottom: 6.5vh;
    border: none;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-1::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-error,
  .input-error:focus,
  .input-error::selection {
    width: 20vw;
    height: 47px;
    border-radius: 30px;
    background: #fff;
    border: 1px solid rgba(255, 0, 0, 0.601);
    margin-bottom: 6.5vh;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-error::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-min,
  .input-min:focus,
  .input-min::selection {
    width: 20vw;
    height: 47px;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
    margin-bottom: 6.5vh;
    border: none;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-min::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-min-error,
  .input-min-error:focus,
  .input-min-error::selection {
    width: 20vw;
    height: 47px;
    border-radius: 30px;
    background: #fff;
    border: 1px solid rgba(255, 0, 0, 0.601);
    margin-bottom: 6.5vh;
    outline: none;
    padding-left: 20px;
    color: #181818;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  .input-min-error::placeholder {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
  }
  #form-row-2 {
    padding-left: 4vw;
    padding-top: 0px;
    padding-top: 1vh;
    margin-bottom: 2.9vh;
  }
  #form-row-2 h3 {
    color: #111010;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-bottom: 7px;
    margin-left: 1vw;
  }
  #form-row-2 h2 {
    color: var(--brand-color, #25ad34);
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-left: 1vw;
  }
  #pricing {
    display: inline-flex;
  }
  #price-info1 {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    width: 12vw;
    float: left;
    margin-left: 3vw;
    margin-top: -1vh;
  }
  #price-info2 {
    color: #8d8d8d;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    float: left;
    margin-top: 1vh;
    margin-left: 0.75vw;
    margin-bottom: 70px;
  }
  .error-message {
    font-family: Inter;
    font-size: 14px;
    color: rgba(255, 0, 0, 0.601);
    font-weight: 400;
    margin-top: -44px;
    margin-left: 10px;
  }
  #generate-price {
    display: flex;
  }
  .generate-passive {
    margin-left: 10vw;
    width: 238px;
    height: 43px;
    border-radius: 16px;
    background: var(--Brand-color-3, #8d8d8d);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--White, #fff);
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .generate-active {
    margin-left: 10vw;
    width: 238px;
    height: 43px;
    border-radius: 16px;
    background: var(--brand-color, #25ad34);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--White, #fff);
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  #loader {
    width: 100vw;
    display: flex;
    justify-content: center;
    margin-top: 1vh;
    margin-bottom: 1vh;
  }
  #message {
    padding-top: 15vh;
    margin-bottom: 10vh;
  }
  #heading {
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-bottom: 5vh;
  }
  #content {
    color: #242424;
    text-align: center;
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px; /* 142.857% */
    letter-spacing: 0.2px;
    margin-top: 2vh;
    margin-bottom: 5vh;
    width: 50vw;
    margin-left: 25vw;
  }
  .small-error-message {
    font-size: 16px;
    font-family: Inter;
    color: rgba(255, 0, 0, 0.601);
    margin-top: -44px;
    margin-left: 4px;
  }
}
</style>
